import dayjs from "dayjs";

/**
 * 작업시간(시분) 선택 모달 (BS)
 */
export default class WorkTime {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
    }

    getHtml = function(){
        const hourCells = Array.from({length: 24}, (_, i) => {
            const v = String(i).padStart(2, '0');
            return `<div class="item flex number-font" data-value="${v}">${v}<span class="fz_11 fw_medium mt-05 mt-4">시</span></div>`;
        }).join('');
        const minuteCells = ['00','10','20','30','40','50'].map(v => {
            return `<div class="item flex number-font" data-value="${v}">${v}<span class="fz_11 fw_medium mt-05 mt-4">분</span></div>`;
        }).join('');

        return `
<div id="window-worktime" class="arrive_time flex_column">
    <div class="title">시 선택</div>
    <div class="hour_grid" id="window-worktime-hour-group">${hourCells}</div>
    <div class="title">분 선택</div>
    <div class="minute_grid" id="window-worktime-minute-group">${minuteCells}</div>
</div>`;
    }

    init = function() {
        this.parent.setTitle('도착시간');
        $('#' + this.id).html(this.getHtml());
        this.draw();
        this.initHandler();
    }

    destroy() {
        $('#window-worktime').off();
    }

    initHandler = function() {
        const self = this;

        $('#window-worktime-hour-group .item').off().on('click',function(){
            let work_time = self.data['work_time'];
            let work_day = dayjs(work_time).format('YYYY-MM-DD');
            let hh = $(this).attr('data-value');
            let mm = dayjs(work_time).format('mm');
            work_time = `${work_day} ${hh}:${mm}:00`;
            const d = $j.F.Car.getTimeFields(work_time);
            self.data['work_start_h'] = d['work_start_h'];
            self.data['work_start_m'] = d['work_start_m'];
            self.data['work_day'] = d['work_day'];
            self.data['work_time']=work_time;
            self.draw();
        });

        $('#window-worktime-minute-group .item').off().on('click',function(){
            let work_time = self.data['work_time'];
            let work_day = dayjs(work_time).format('YYYY-MM-DD');
            let hh = dayjs(work_time).format('HH');
            let mm = $(this).attr('data-value');
            work_time = `${work_day} ${hh}:${mm}:00`;
            const d = $j.F.Car.getTimeFields(work_time);
            self.data['work_start_h'] = d['work_start_h'];
            self.data['work_start_m'] = d['work_start_m'];
            self.data['work_day'] = d['work_day'];
            self.data['work_time']=work_time;
            self.draw();
            self.apply();
        });
    }

    draw = function(){
        const work_time = this.data['work_time'];
        let hh = dayjs(work_time).format('HH');
        let mm = dayjs(work_time).format('mm');
        $('#window-worktime-hour-group .item').each(function(idx,el){
            const hour = $(el).attr('data-value');
            if( hour==hh ) $(el).addClass('on');
            else $(el).removeClass('on');
        });
        $('#window-worktime-minute-group .item').each(function(idx,el){
            const minute = $(el).attr('data-value');
            if( minute==mm ) $(el).addClass('on');
            else $(el).removeClass('on');
        });
    }

    apply = function(){
        // close 호출하지 않음 — onApply 가 다음 단계 BS 로 전환(또는 종료) 책임짐
        const cb = this.data?.onApply;
        if (typeof cb === 'function') cb(this.data);
    }
}
